import { useEffect, useRef, useState } from 'react';
import { useIsScrolling } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/station/kalenderScrollStore';

export function useHoverPopover() {
  const ref = useRef<HTMLDivElement>(null);
  const isScrolling = useIsScrolling();
  const [open, setOpen] = useState(false);
  const [cursorX, setCursorX] = useState(0);

  const handleMouseEnter = (event: React.MouseEvent) => {
    if (!ref.current) {
      return;
    }

    setOpen(true);
    setCursorX(event.clientX - ref.current.getBoundingClientRect().left);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isScrolling && open) {
      setOpen(false);
    }
  }, [isScrolling, open]);

  return {
    ref,
    open,
    setOpen,
    cursorX,
    handleMouseEnter,
    handleMouseLeave,
  };
}
